export const formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMinutes = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffDays > 0) {
        return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
    } else if (diffHours > 0) {
        const remainingMinutes = diffMinutes % 60;
        return `${diffHours} hr${diffHours > 1 ? 's' : ''} ${remainingMinutes} min${remainingMinutes > 1 ? 's' : ''} ago`;
    } else {
        return `${diffMinutes} min${diffMinutes > 1 ? 's' : ''} ago`;
    }
};


export const getTitle = (item) => {
    const actionType = item.action.split(' ')[0]; // Get the first word of the action
    switch (actionType) {
      case 'create': // If action title include create
        if (item.action.includes('section')) {
          const data = JSON.parse(item.data);
          return `${item.action}  ${data.days} ${data.time_period} to ${data.group}`;
        } else if (item.action.includes('student')) {
          const data = JSON.parse(item.data);
          return `${item.action}  ${data.name}`;
        }
        break;
      case 'delete': // If action title include delete
        if (item.action.includes('section')) {
          const data = JSON.parse(item.data);
          return `${item.action}  ${data.days} ${data.time_period} from ${data.group}`;
        } else if (item.action.includes('student')) {
          const data = JSON.parse(item.data);
          return `${item.action}  ${data.name}`;
        }
        break;
      case 'update':
        if (item.action.includes('section')) {
          const data = JSON.parse(item.data);
          return `${item.action}  at ${data.group}`;
        } else if (item.action.includes('student')) {
          const data = JSON.parse(item.data);
          return `${item.action}  ${data.name}`;
        }
        break;
      default:
        return item.action;
    }
  };
  